<app-card-medium title="{{ 'Settings' | translate }}">
    <div style="display: flex; flex-direction: column; align-items: center;">
        <div class="content scrollable">
            <li class="list-group-item" *ngFor="let setting of settings; trackById">
                <div style="display: flex; justify-content: space-between;">
                    <app-toggle-switch [selected]="setting.value" [forOthers]="true"
                        (change)="setting.value = !setting.value"></app-toggle-switch>
                    <p>{{ setting.name | translate }}</p>
                </div>
            </li>
        </div>
        <button class="btn btn-sm btn-primary" style="margin-top: 1em; width: 200px;" (click)="onClickSave()">{{'Save' | translate}}</button>
    </div>
</app-card-medium>